import { MAX_REDACT_DEPTH as E, REDACTED as a, SENSITIVE_KEYS as A } from "./constants.js";
const i = (r) => r !== null && typeof r == "object" && !Array.isArray(r), n = (r, o = 0) => {
  if (o >= E)
    return r;
  if (Array.isArray(r))
    return r.map((s) => n(s, o + 1));
  if (i(r)) {
    const s = {};
    for (const [t, f] of Object.entries(r))
      s[t] = A.has(t.toLowerCase()) ? a : n(f, o + 1);
    return s;
  }
  return r;
}, d = (r, o) => [
  r == null ? void 0 : r.err,
  r == null ? void 0 : r.error,
  ...o
].find(
  (t) => t instanceof Error
);
export {
  d as findError,
  i as isPlainObject,
  n as redact
};
